import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import { registerSW } from "./lib/registerSW";
import { initErrorReporting } from "@/shared/lib/errorReporting";
import { initTheme } from "@/shared/hooks/useTheme";
import { bootstrapBrand } from "@/shared/brand";
import { PartnerNotFoundGate } from "@/shared/brand/PartnerNotFoundGate";
import "./index.css";
// 必须在任何 useGSAP 组件渲染前执行:否则 context 收不到 tween,卸载时漏动画。
import "@/shared/motion/registerGsap";

// 可观测性(契约 §4):未配 DSN 时只挂两个空监听器,load 后发现没配即卸掉;SDK 不进首屏。
initErrorReporting("main");
registerSW();
initTheme(); // render 前落定主题(localStorage)→ 消除首帧 :root 默认→服务端主题的翻转
// OEM 贴牌:createRoot 之前落定品牌(缓存即用 / 渠道域名最多等 1500ms / 失败按直营白名单回落)。
void bootstrapBrand("main").finally(() => {
  createRoot(document.getElementById("root")!).render(
    <PartnerNotFoundGate>
      <App />
    </PartnerNotFoundGate>
  );
});
